import React from "react";
import { ApiEnvelopeStatus } from "src/api/types";
import EnvelopeStatus from "src/components/signer/EnvelopeStatus";
import useWindowSize from "src/hooks/useWindowSize";

interface SignerLayoutTitleProps {
	title: string;
	status: ApiEnvelopeStatus;
}

const SignerLayoutTitle = ({ title, status }: SignerLayoutTitleProps) => {
	const length = title.length;
	const showGradient = length >= 23;
	const size = useWindowSize();

	const renderGradient = () => {
		return (
			<div className="absolute top-0 bottom-0 right-0 bg-gradient-to-l from-gray-background w-8"></div>
		);
	};

	if (size.isPhone) {
		return <></>;
	}

	return (
		<div className="flex items-center flex-1 relative w-full gap-[12px]">
			<div className="max-w-[360px] hidden md:flex overflow-hidden relative">
				<h2 className="whitespace-nowrap">{title}</h2>
				{showGradient && renderGradient()}
			</div>
			<EnvelopeStatus status={status} />
		</div>
	);
};

export default SignerLayoutTitle;
